module.exports = {
  _name: "#model",
  _v: 1,
  mixins: [require("./directives")],
  _attrLookup: {
    model: {
      "#": function(o) {
        var event;
        event = (function() {
          switch (o.el.type) {
            case "checkbox":
            case "radio":
            case "select-one":
            case "select-multiple":
              return "change";
            default:
              return "input";
          }
        })();
        o.path = o.value;
        this.$path.toNameAndParent(o);
        o.el.addEventListener(event, (function(_this) {
          return function(e) {
            if (o.parent[o.name] !== e.target.value) {
              return o.parent[o.name] = e.target.value;
            }
          };
        })(this));
        return this.$watch.path({
          path: o.value,
          cbs: function(value) {
            if (o.el.value !== value) {
              return o.el.value = value;
            }
          }
        });
      }
    }
  }
};

;



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/#model.js
// module id = 46
// module chunks = 1